import PERMISSIONS_LIST from '../../../../../../../submodules/web-shared/modules/Permissions/permissions-list';
import { COMPANY_SETTING_NAME } from '../../../../companies/api/company-settings/enums/company-settings';
import { useUserCompanies } from '../../../../../../../submodules/web-shared/reducers/user-companies/hooks';
import { portalLevelPermissions } from '../../../../../../../submodules/web-shared/modules/Permissions/PortalLevelPermissions';
import { useUserRole } from '../../../../../../../submodules/web-shared/hooks/useUserRole';

export const useFraudWatchAccess = () => {
  const { isCompanySettingEnabled } = useUserCompanies();
  const { isAdminUser } = useUserRole();

  const hasFraudWatchAccess = () => {
    return isCompanySettingEnabled(COMPANY_SETTING_NAME.INTEL_FEATURE_ACCESS)
      && portalLevelPermissions.isPermissionEnabled(PERMISSIONS_LIST.fraudwatch_access, null);
  };

  const hasPermission = (permission: PERMISSIONS_LIST, portalId?: number | null) => {
    return portalLevelPermissions.isPermissionEnabled(permission, portalId);
  };

  const hasApprovalInfoAccess = (portalId?: number | null) => {
    return hasFraudWatchAccess()
      && hasPermission(PERMISSIONS_LIST.fraudwatch_authorization_access, portalId);
  };

  const hasFraudWatchRisksAccess = (portalId?: number | null) => {
    return hasFraudWatchAccess()
      && hasPermission(PERMISSIONS_LIST.fraudwatch_risks_access, portalId);
  };

  const hasAccessToDriversDashboard = () => {
    return !isAdminUser && hasFraudWatchAccess();
  };

  return {
    hasFraudWatchAccess,
    hasAccessToDriversDashboard,
    hasApprovalInfoAccess,
    hasFraudWatchRisksAccess,
  };
};